/**
 * Generates the Adjust app download link from the current URL parameters.
 */
export const getAdjustAppDownloadLink = () => {
  const adjustSmartScript = (window as unknown as AdjustSmartScriptWindow).AdjustSmartScript;

  if (!adjustSmartScript) return;

  return adjustSmartScript.createLink(ADJUST_LINK_MAPPING);
};

// ─── Constants ───────────────────────────────────────────────────────────────

// This config is auto generated in the Adjust dashboard for the sweetgreen app.
// Whenever marketing updates the parameters, this needs to be updated, web only.
const ADJUST_LINK_MAPPING = {
  defaultLinkToken: '25pqs0c2',
  domain: 'sweetgreen.go.link',
  campaign: {
    in: 'utm_campaign',
    defaultValue: 'web_to_app_campaign',
  },
  adgroup: {
    in: 'utm_content',
    defaultValue: 'web_to_app_adgroup',
  },
  creative: {
    in: 'utm_term',
    defaultValue: 'web_to_app_creative',
  },
  fallbackClick: false,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type AdjustLinkMapping = typeof ADJUST_LINK_MAPPING;

type AdjustSmartScript = {
  createLink: (mapping: AdjustLinkMapping) => string;
};

type AdjustSmartScriptWindow = {
  AdjustSmartScript?: AdjustSmartScript;
};
